module.exports = __webpack_public_path__ + "static/media/oops_caption.95f5ec22.svg";